import { Children } from "react";
import { Navigate,useLocation } from "react-router-dom";
const ProtectedRoute=({children})=>{
    const account =localStorage.getItem('account');
    const location=useLocation();
    if(!account){
       return <Navigate to="/Login" state={{from:location}}/>
    }
    return children
}
export default ProtectedRoute;